import Map from 'ol/Map'
import { useEffect, useRef } from 'react'

export default function useMapResize(
  map: Map | null | undefined,
  element: HTMLElement | null | undefined,
  onFirstResize?: () => void
) {
  const isFirst = useRef<boolean>(true)
  useEffect(() => {
    if (map && element) {
      const resizeObserver = new ResizeObserver(() => {
        map.updateSize()
        if (onFirstResize && isFirst.current) {
          onFirstResize()
        }
        isFirst.current = false
      })
      resizeObserver.observe(element)

      return () => {
        resizeObserver.unobserve(element)
      }
    }
  }, [map, element, onFirstResize])
}
